import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { IRide } from '../types';
import {
  activeRideIndexAtom,
  isRideActiveAtom,
  pauseAtom,
  playAtom,
  selectedRidesAtom,
  showAllRidesAtom,
  showSelectRidesModalAtom,
  stopAtom,
} from '../RidePlayerState';
import useAnalytics from '../../../hooks/useAnalytics';

interface ISelectRidesWidgetProps {
  rides: IRide[];
}

export default function SelectRidesWiget(props: ISelectRidesWidgetProps): JSX.Element {
  const { trackEvent } = useAnalytics();
  const { formatMessage: f } = useIntl();
  const setShowSelectRidesModal = useSetRecoilState<boolean>(showSelectRidesModalAtom);
  const play = useRecoilValue<boolean>(playAtom);
  const setPause = useSetRecoilState<boolean>(pauseAtom);
  const showAllRides = useRecoilValue<boolean>(showAllRidesAtom);
  const isRideActive = useRecoilValue<number | false>(isRideActiveAtom);
  const stop = useRecoilValue<boolean>(stopAtom);
  const activeRideIndex = useRecoilValue<number>(activeRideIndexAtom);
  const selectedRides = useRecoilValue<number[]>(selectedRidesAtom);
  const activeRideNumber = selectedRides[activeRideIndex];

  const handleOpenModal = () => {
    // When ride is played, pause it
    if (play) {
      setPause(true);
    }
    trackEvent(['Select rides widget', 'click', 'Open select rides modal']);
    setShowSelectRidesModal(true);
  };

  const numberOfSelectedRides = (): number => {
    return selectedRides.length;
  };

  const getActiveRideNumber = (): string | number => {
    if (props.rides.length === 1) {
      return `${activeRideNumber}.`;
    }
    if (showAllRides && !isRideActive) {
      return numberOfSelectedRides();
    }

    if (!showAllRides && !isRideActive && !stop && !play) {
      return numberOfSelectedRides();
    }

    if (!showAllRides && isRideActive && stop && play) {
      if (selectedRides.includes(activeRideNumber)) {
        return `${activeRideNumber}.`;
      }
      // const lastRideNumber = Object.keys(selectedRides)
      //   .filter((rideNumber: string) => selectedRides[rideNumber])
      //   .reverse()[0];
      const lastRideNumber = selectedRides[selectedRides.length - 1];
      return `${lastRideNumber}.`;
    }
    if (!showAllRides && isRideActive && !stop && !play) {
      if (selectedRides.includes(activeRideNumber)) {
        return `${activeRideNumber}.`;
      }
      const lastRideNumber = selectedRides[selectedRides.length - 1];
      return `${lastRideNumber}.`;
    }
    return `${activeRideNumber}.`;
  };

  return (
    <div className="item">
      <div className="b-widget b-widget--1x1 b-widget--selectRide hover" onClick={handleOpenModal}>
        <div className="info">
          {props.rides.length === numberOfSelectedRides() &&
            f({ id: 'ridePlayer.widget.selectRide.selectRides' })}
          {props.rides.length !== numberOfSelectedRides() &&
            f({ id: 'ridePlayer.widget.selectRide.selectedRides' })}
        </div>
        <i className="e-widget-icon cmd-icon cmd-icon-driving-overview" />
        <div className="widget-label">
          {getActiveRideNumber()}/{props.rides.length}
        </div>
      </div>
    </div>
  );
}
